export const MaxDate = new Date('9999-12-31T23:59:59.999Z') // December 31, 9999 - safe for external APIs
